import { useCallback } from 'react'
import { doc } from 'firebase/firestore'
import { db } from '../lib/firebase'
import { updateDoc } from '../lib/firestore'
import { uploadAvatar } from '../lib/avatarUpload'
import { track } from '../lib/analytics'

/** The signed-in user's own profile edits. Each mutation throws on failure; the caller owns the UI. */
export function useProfileEditor(uid: string | null) {
  const setAvatar = useCallback(
    async (blob: Blob) => {
      if (!uid) return
      const url = await uploadAvatar(uid, blob)
      await updateDoc(doc(db, 'users', uid), { photoURL: url })
      track('avatar_updated', { method: 'upload' })
    },
    [uid],
  )

  const removeAvatar = useCallback(async () => {
    if (!uid) return
    await updateDoc(doc(db, 'users', uid), { photoURL: null })
    track('avatar_updated', { method: 'removed' })
  }, [uid])

  const saveDisplayName = useCallback(
    async (displayName: string) => {
      if (!uid) return
      await updateDoc(doc(db, 'users', uid), { displayName })
      track('display_name_updated', {})
    },
    [uid],
  )

  return { setAvatar, removeAvatar, saveDisplayName }
}
